module.exports = __webpack_public_path__ + "img/selected6-min.76ea1d0f.png";